import { Component, Input, OnInit } from "@angular/core"
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap"
import { UserService } from "../../../../services/user.service"
import { StudentLoginModalComponent } from "../../student-login-modal/student-login-modal.component"
import { AuthModalComponent } from "../auth-modal.component"
import { StudentLogin } from "../../../../models/studentLogin"
import { Router } from "@angular/router"

@Component({
    selector: "app-auth-modal-content",
    templateUrl: "./auth-modal-content.component.html",
    styleUrls: ["./auth-modal-content.component.less"],
})
export class AuthModalContentComponent implements OnInit {
    public isStudent = false
    public googleImage
    public facebookImage
    public pbsImage
    public isStudentTab: boolean = false
    public studentUsername: string = null
    public secretAnswer: string = null
    public studentLogin: StudentLogin

    @Input() public nextURL: string = null
    @Input() public overrideStudentNext: boolean = false
    @Input() public activeModal: NgbActiveModal = null
    @Input() public title: string = "Welcome back!"
    @Input() public description: string
    @Input() public registerDescription: string = "Need an account?"
    @Input() public registerLinkText: string = "Click here to get started."
    @Input() public pbsEmailRegister: boolean = false

    constructor(
        public userService: UserService,
        private modalService: NgbModal,
        private router: Router
    ) {
        this.googleImage = require("../../../../../assets/auth-google.svg")
        this.facebookImage = require("../../../../../assets/auth-facebook.svg")
        this.studentLogin = new StudentLogin(this.userService, this.router)
    }

    public ngOnInit() {
        this.isStudent = this.userService.hasStudentExperience()

        if (!this.description) {
            this.description =
                "Use one of the services below to sign in to PBS LearningMedia:"
        }
    }

    public activateStudentTab() {
        this.description =
            "Access your assignments, projects, and favorites by signing in."
        this.isStudentTab = true
    }

    public activateTeacherTab() {
        this.description =
            "Use one of the services below to sign in to PBS LearningMedia:"
        this.isStudentTab = false
    }

    public closeAuthModal() {
        if (this.activeModal) {
            this.activeModal.close()
        }
    }

    public openAuthModal() {
        const modalRef = this.modalService.open(AuthModalComponent)
        modalRef.componentInstance.nextURL = this.nextURL
        modalRef.componentInstance.overrideStudentNext = true
    }

    public openStudentAuthModal() {
        this.modalService.open(StudentLoginModalComponent)
    }

    public getStudentUrl() {
        return (
            "/student/signup/?next=" +
            (this.overrideStudentNext ? this.nextURL : "/student/")
        )
    }

    public getStudentNext() {
        return this.overrideStudentNext
            ? this.nextURL
            : this.studentLogin.getCurrentStudentPath()
    }
}
